import { render, staticRenderFns } from "./PaytableDesktop.vue?vue&type=template&id=063864d9&"
import script from "./PaytableDesktop.vue?vue&type=script&lang=ts&"
export * from "./PaytableDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./PaytableDesktop.vue?vue&type=style&index=0&id=063864d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports